import axios from 'axios';
import history from './history';
import _ from 'lodash';
import {checkAndRefresh, fetchError, FETCH_MODELS, FETCH_USERS, FETCH_USER, ADD_ADDRESS, UNAUTH_USER} from './index'
import {START_LOADING, END_LOADING} from './loadingActions'
import {reset} from "redux-form";

export const FETCH_CLIENT = "fetch_client";
export const ADD_ADDRESS_CLIENT = "add_address_client";
export const RESET_CLIENT = "reset_client";

export function fetchClient(id) {
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            axios.get(`/api/clients/${id}`).then( response  => {
                dispatch({
                    type: FETCH_CLIENT,
                    payload: response
                });
            }).catch(error=>{
                fetchError( dispatch, error )
            });
        })
    }
}
export function approveClient(data) {
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            axios.patch(`/api/clients/approve/${data}`).then( response  => {
                dispatch({
                    type: FETCH_USERS,
                    payload: response
                });
            }).catch(error=>{
                fetchError( dispatch, error )
            });
        })
    }
}
export function deleteModelos(data) {
    return function(dispatch){
        dispatch({
            type: START_LOADING
        })
        checkAndRefresh(dispatch).then((newToken)=>{
            axios.post(`/api/modelo/delete`, data).then( response  => {
                dispatch({
                    type: FETCH_MODELS,
                    payload: _.omit(response.data, 'comments')
                });
                dispatch({
                    type: END_LOADING
                })

            }).catch(error=>{
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function reorderModels(data, casoId) {
    return function(dispatch){
        dispatch({
            type: START_LOADING
        })
        checkAndRefresh(dispatch).then((newToken)=>{
            axios.patch(`/api/caso/${casoId}/reorder`, data).then(response => {
                dispatch({
                    type: FETCH_MODELS,
                    payload: _.omit(response.data, 'comments')
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error=>{
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function updateClient(data, userId){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.patch(`/api/user/${userId}`, data).then(response => {
                dispatch({
                    type: FETCH_CLIENT,
                    payload: {data: response.data.result}
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function addAddressToClient(data, clientId) {
    if(clientId) data.clientId = clientId;
    return function(dispatch) {
        axios.post(`/api/address/new`, data).then(response => {
            dispatch({
                type: ADD_ADDRESS_CLIENT,
                payload: response
            })
            dispatch({
                type: END_LOADING
            })
            dispatch(reset('addAddress'))
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function addNote(data) {
    return function(dispatch) {
        axios.post(`/api/note/new`, data).then(response => {
            dispatch({
                type: FETCH_MODELS,
                payload: _.omit(response.data, 'comments')
            });
            dispatch({
                type: END_LOADING
            });
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function removeNote(id) {
    return function(dispatch) {
        axios.delete(`/api/note/${id}`,).then(response => {
            dispatch({
                type: FETCH_MODELS,
                payload: _.omit(response.data, 'comments')
            });
            dispatch({
                type: END_LOADING
            });
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function updateNote(data) {
    return function(dispatch) {
        axios.patch(`/api/note/${data.id}`, data).then(response => {
            dispatch({
                type: FETCH_MODELS,
                payload: _.omit(response.data, 'comments')
            });
            dispatch({
                type: END_LOADING
            });
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function resetClient() {
    localStorage.removeItem('token');
    return { type: RESET_CLIENT }
}


// WEBPACK FOOTER //
// ./resources/assets/js/actions/admin.js